import React, { useImperativeHandle, forwardRef, useRef } from 'react';
import { useRefresh, useNotify } from 'react-admin';

import { DialogoConfirmacao } from '..';

import { api } from '../../services';

const FormDialog = forwardRef(({ campoAtivo }, ref) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const refDialogoConfirmacao = useRef(null);

  useImperativeHandle(ref, () => ({
    handleOpen(record) {
      if (refDialogoConfirmacao.current) {
        refDialogoConfirmacao.current.handleOpen(
          !record.ativo ? 'Ativação de Recurso' : 'Desativação de Recurso',
          'Tem certeza da modificação do status desse recurso',
          record,
        );
      }
    },
  }));

  async function handleConfirma(record) {
    await api.put(`/${record.resource}/${record.id}`, {
      [campoAtivo]: !record[campoAtivo],
    });
    refresh();
  }

  return (
    <DialogoConfirmacao
      ref={refDialogoConfirmacao}
      handleConfirma={handleConfirma}
    />
  );
});

export default FormDialog;
